module.exports = __webpack_public_path__ + "img/list_Story_28.740dbbb6.jpeg";